import api from './client';
import type { InverterDetail } from './inverterDetail';
export type PlantFlowHistory = {
  at: string | null;
  records: string[];
  timezone: string;
  inverters: { id: number; inverter_name: string; detail: InverterDetail }[];
};
export async function fetchPlantFlowHistory(uuid: string, date: string, time: string): Promise<PlantFlowHistory> {
  return (await api.get<PlantFlowHistory>(`/powerplants/${uuid}/flow-history`, { params: { date, time } })).data;
}
